export default __webpack_public_path__ + "static/4-aa2408960c2db0640d64a7a0afa59ca9.jpg";